import React from 'react';
import { Col, Input, Row } from 'antd';

class InputField extends React.Component {
    render() {
        const { link, src, title } = this.props.item;
        // console.log(this.props)
        return(
            <div>
                <Row>

                    <Col span={3}>
                        Title   
                    </Col>

                    <Col span={20}>
                        <Input 
                            id="title"
                            size="small"
                            onChange={this.handleChange}
                            value={title}
                            />
                    </Col>
                    
                </Row>

                <Row>

                    <Col span={3}>
                        Src:
                    </Col>

                    <Col span={20}>
                        <Input 
                            id="src"
                            size="small"
                            onChange={this.handleChange}
                            value={src}/>
                    </Col>
                    
                </Row>

                <Row>

                    <Col span={3}>
                        Link:
                    </Col>

                    <Col span={20}>
                        <Input 
                            id="link"
                            size="small"
                            onChange={this.handleChange}
                            value={link}/>
                    </Col>
                    
                </Row>
            </div>
        )
    }

    handleChange = (e) => {
        console.log("props passed into input" , this.props.item)
        this.props.handleChange(e.target.value, e.target.id, this.props.index)
    }

}

export default InputField;


// WEBPACK FOOTER //
// ./src/components/featured/modal/input.js